import React from "react"
import { TopBar } from "../ui/Frame"
import { Button } from "ui"
const Spacer = () => <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

const HeaderBar = props => {
    return (
        <TopBar>
            <Button onClick={props.save} noRadius size="small" margin="none" icon="save">
                Save
            </Button>
            <Button onClick={props.undo} noRadius size="small" margin="none" icon="undo">
                Undo
            </Button>
            <Spacer />
            <Button onClick={props.copy} noRadius size="small" margin="none" icon="copy">
                Copy
            </Button>
            <Button onClick={props.paste} noRadius size="small" margin="none" icon="paste">
                Paste
            </Button>
            <Button
                onClick={props.formatPaint}
                noRadius
                size="small"
                margin="none"
                icon="paint-brush"
            >
                Format Paint
            </Button>
            <Button onClick={props.remove} noRadius size="small" margin="none" icon="trash">
                Remove
            </Button>
            <Spacer />
            <Button
                onClick={props.viewDesktop}
                noRadius
                size="small"
                margin="none"
                icon="desktop-alt"
            />
            <Button
                onClick={props.viewMobile}
                noRadius
                size="small"
                margin="none"
                icon="mobile-android-alt"
            />
        </TopBar>
    )
}

export default HeaderBar



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/HeaderBar.js